import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full h-full" }



export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LoadingComponent' },
  __name: 'LoadingComponent',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "flex justify-center items-center space-x-1 text-sm text-gray-700" }, [
      _createElementVNode("svg", {
        fill: "none",
        class: "w-6 h-6 animate-spin",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          "clip-rule": "evenodd",
          d: "M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z",
          fill: "currentColor",
          "fill-rule": "evenodd"
        })
      ])
    ], -1)
  ])))
}
}

})